import moment from 'moment';
import { CronJob } from 'cron';
import { useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { pmInfoNoticeAPI } from '../api/commonAPI';
import { useAlert } from '.';
import { setPmNoticeInfo } from '../redux/pmNotice';
import { appKillFunc, getUrlParams } from '../utils/utilityEtc';

let job = null;
export default function usePmChecker() {
  const dispatch = useDispatch();
  const [Alert] = useAlert();
  const deviceInfo = useSelector( state => state.deviceInfo );

  // 스케줄러 시작
  const start = useCallback(() => {
    
    // 이미 스케줄러 돌고 있다면 return;
    pmInfoNoticeAPICall();
    if (job) return;

    console.log("##### CronJob PM Notice Start: ", moment().format('YYYY. MM. DD HH:mm:ss'));

    job = new CronJob(
      '*/10 * * * *',
      function () {
        console.log("##### CronJob message test", job.nextDate().format('YYYY. MM. DD HH:mm:ss'));
        pmInfoNoticeAPICall();
      },
    )
    job.start();
  }, []);

  // 스케줄러 중지
  const stop = useCallback(() => {
    if (job) job.stop();
  }, []);

  // pm 공지 API 조회
  const pmInfoNoticeAPICall = useCallback(async () => {
    try {
      const gbAppParams = localStorage.getItem('gb_app_params');
      const parsed = getUrlParams(gbAppParams);

      const locale = parsed?.LOCALE;
      const channelCode = parsed?.CHN_CD;
    
      const resp = await pmInfoNoticeAPI(locale, channelCode);
      if (!resp) return;
      const { noticeAlert, jobMessage } = resp;
      if (noticeAlert) {
        Alert(
          jobMessage.replace(/\\n/gi, "</br>"),
          () => {
            appKillFunc({ deviceInfo });
          }
        );
      }
      dispatch(setPmNoticeInfo(resp));
    } catch (error) {
      console.log("##### pmInfoNoticeAPICall error: ", error);
    }
  }, []);

  return [stop, start];
}